import api from "./api";

export const getHomeData = async () => {
    try {
        const res = await api.get("/api/home");
        return res?.data || { services: [], news: [] };
    } catch (error) {
        console.error("Error fetching home data:", error);
        return { services: [], news: [] };
    }
};



